import React from "react";
import PropTypes from "prop-types";
import DisplayPicture from "../DisplayPicture/DisplayPicture";

import style from "./GroupDetailsCard.module.css";
export default function GroupDetailsCard({
  id,
  isAdmin,
  role,
  userName,
  image,
  gender,
  weight,
  isAdminLoggedIn,
  selectGroupMember,
  selectedGroupMemberActions,
  isCustomGroup,
}) {
  const localSelectGroupMember = () => {
    selectGroupMember(
      id,
      isAdmin,
      role,
      userName,
      image,
      gender,
      weight,
      selectedGroupMemberActions.delete
    );
  };

  return (
    <>
      <div
        className={`${style.container} d-flex align-items-center justify-content-between p-2 rounded`}
      >
        <div className="d-flex align-items-center">
          <DisplayPicture image={image} className="profileImage mr-3" />
          <div>{userName}</div>
        </div>
        {isAdminLoggedIn && isCustomGroup ? (
          isAdmin ? (
            <div className="groupLabel rounded">Admin</div>
          ) : (
            <div onClick={localSelectGroupMember}>
              <i
                className={`mdi mdi-delete pointerCursor hoverDanger ${style.iconStyle}`}
              ></i>
            </div>
          )
        ) : (
          isAdmin && <div className="groupLabel rounded">Admin</div>
        )}
      </div>
      <hr className="m-0" />
    </>
  );
}

GroupDetailsCard.propTypes = {
  id: PropTypes.string,
  isAdmin: PropTypes.string,
  role: PropTypes.string,
  userName: PropTypes.string,
  image: PropTypes.string,
  gender: PropTypes.string,
  weight: PropTypes.string,
  isAdminLoggedIn: PropTypes.bool,
  selectGroupMember: PropTypes.func,
  selectedGroupMemberActions: PropTypes.object,
  isCustomGroup: PropTypes.bool,
};
